export const ADMIN_PERMISSIONS = {
  VIEW_MENTORS: 'VIEW_MENTORS',
  APPROVE_MENTORS: 'APPROVE_MENTORS',
  MANAGE_MENTORS: 'MANAGE_MENTORS',
  DELETE_MENTORS: 'DELETE_MENTORS',
  VIEW_STUDENTS: 'VIEW_STUDENTS',
  MANAGE_STUDENTS: 'MANAGE_STUDENTS',
  VIEW_PAYMENTS: 'VIEW_PAYMENTS',
  MANAGE_PAYMENTS: 'MANAGE_PAYMENTS',
  VIEW_FEEDBACK: 'VIEW_FEEDBACK',
  MANAGE_FEEDBACK: 'MANAGE_FEEDBACK',
  VIEW_SUPPORT: 'VIEW_SUPPORT',
  MANAGE_SUPPORT: 'MANAGE_SUPPORT',
  VIEW_ANALYTICS: 'VIEW_ANALYTICS',
  MANAGE_ADMINS: 'MANAGE_ADMINS',
  VIEW_USERS: 'VIEW_USERS',
  MANAGE_USERS: 'MANAGE_USERS',
};

export const ADMIN_ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  SUPPORT_ADMIN: 'support_admin',
  CONTENT_ADMIN: 'content_admin',
};

export const ROLE_PERMISSIONS = {
  [ADMIN_ROLES.SUPER_ADMIN]: [
    ADMIN_PERMISSIONS.MANAGE_MENTORS,
    ADMIN_PERMISSIONS.DELETE_MENTORS,
    ADMIN_PERMISSIONS.MANAGE_FEEDBACK,
    ADMIN_PERMISSIONS.MANAGE_SUPPORT,
    ADMIN_PERMISSIONS.MANAGE_USERS,
    ADMIN_PERMISSIONS.MANAGE_STUDENTS,
    ADMIN_PERMISSIONS.VIEW_ANALYTICS,
    ADMIN_PERMISSIONS.ASSIGN_TICKETS,
    ADMIN_PERMISSIONS.MANAGE_CONTENT,
    ADMIN_PERMISSIONS.SYSTEM_SETTINGS,
  ],
  [ADMIN_ROLES.ADMIN]: [
    ADMIN_PERMISSIONS.MANAGE_MENTORS,
    ADMIN_PERMISSIONS.DELETE_MENTORS,
    ADMIN_PERMISSIONS.MANAGE_FEEDBACK,
    ADMIN_PERMISSIONS.MANAGE_SUPPORT,
    ADMIN_PERMISSIONS.MANAGE_USERS,
    ADMIN_PERMISSIONS.MANAGE_STUDENTS,
    ADMIN_PERMISSIONS.VIEW_ANALYTICS,
    ADMIN_PERMISSIONS.ASSIGN_TICKETS,
  ],
  [ADMIN_ROLES.SUPPORT_ADMIN]: [
    ADMIN_PERMISSIONS.MANAGE_SUPPORT,
    ADMIN_PERMISSIONS.MANAGE_FEEDBACK,
    ADMIN_PERMISSIONS.ASSIGN_TICKETS,
  ],
  [ADMIN_ROLES.CONTENT_ADMIN]: [
    ADMIN_PERMISSIONS.MANAGE_CONTENT,
    ADMIN_PERMISSIONS.VIEW_ANALYTICS,
  ],
};

export const FEEDBACK_TYPES = {
  GENERAL: 'general',
  FEATURE_REQUEST: 'feature_request',
  BUG_REPORT: 'bug_report',
  UI_UX: 'ui_ux',
  PERFORMANCE: 'performance',
  OTHER: 'other',
};

export const FEEDBACK_STATUS = {
  PENDING: 'pending',
  REVIEWED: 'reviewed',
  ADDRESSED: 'addressed',
  ARCHIVED: 'archived',
};

export const TICKET_STATUS = {
  OPEN: 'open',
  IN_PROGRESS: 'in_progress',
  WAITING_FOR_USER: 'waiting_for_user',
  RESOLVED: 'resolved',
  CLOSED: 'closed',
  REOPENED: 'reopened',
};

export const TICKET_PRIORITY = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
  URGENT: 'urgent',
};

export const TICKET_CATEGORY = {
  TECHNICAL: 'technical',
  ACCOUNT: 'account',
  PAYMENT: 'payment',
  FEATURE_REQUEST: 'feature_request',
  BUG_REPORT: 'bug_report',
  GENERAL: 'general',
  OTHER: 'other',
};

export const ADMIN_ROUTES = {
  DASHBOARD: '/admin/dashboard',
  MENTORS: '/admin/mentors',
  MENTOR_REVIEW: '/admin/mentors/:mentorId',
  FEEDBACK: '/admin/feedback',
  FEEDBACK_DETAILS: '/admin/feedback/:feedbackId',
  SUPPORT: '/admin/support',
  SUPPORT_TICKET: '/admin/support/:ticketId',
  ANALYTICS: '/admin/analytics',
  USERS: '/admin/users',
  SETTINGS: '/admin/settings',
};
